import { useParams } from 'react-router-dom'
import { getCustomerOrdersDone } from '@/services/api'
import { CustomerOrderTable } from '@/features/sales-order/components/CustomerOrderTable'
import { salesOrderListQueryKeys } from '@/features/sales-order/salesOrderQueries'

export function DonePage() {
  const { workflowId } = useParams<{ workflowId: string }>()

  return (
    <CustomerOrderTable
      queryKeyPrefix={salesOrderListQueryKeys.done(workflowId ?? '')}
      fetchList={getCustomerOrdersDone}
      emptyMessage="No customer orders are done yet"
    />
  )
}
